import { getDefaultStore } from 'jotai'

export const mainStore = getDefaultStore()
